/*
处理手机号格式 (123) 345-6789
 */

export const changePhoneFormat = (phoneNumber: string) => {
  if (String(phoneNumber).length === 10) {
    const a = String(phoneNumber).substring(0, 3);
    const b = String(phoneNumber).substring(3, 6);
    const c = String(phoneNumber).substring(6, 10);
    return '(' + a + ') ' + b + '-' + c;
  } else if (String(phoneNumber).length === 11) {
    const d = String(phoneNumber).substring(0, 1);
    const e = String(phoneNumber).substring(1, 4);
    const f = String(phoneNumber).substring(4, 7);
    const g = String(phoneNumber).substring(7, 11);
    return '+' + d + ' (' + e + ')' + f + '-' + g;
  } else {
    return phoneNumber;
  }
}